import {
  DDP_DETAILS,
  REVYRE_DETAILS,
  REVYRE_FILTERS,
  REVYRE_FORM,
  REVYRE_LIST,
  REVYRE_NOTIFICATION,
  REVYRE_WORKFLOW_DETAILS,
  REVYRE_WORKFLOW_LIST,
  UPLOAD_FORM,
} from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import RevyreList from '.';
import DdpDetails from './ddp';
import DdpThunk from './ddp/thunk';
import RevyreDetails from './details';
import RevyreFilters from './filters';
import RevyreForm from './form';
import RevyreFormThunk from './form/thunk';
import UploadForm from './form/uploadForm';
import RevyreNotificationPopup from './notification';
import RevyreThunk from './thunk';

const module: ModulesList = {
  [REVYRE_WORKFLOW_LIST]: {
    path: '/revyre/:domainType/:workflowType',
    component: RevyreList,
    dialog: {
      styles: {
        d: {
          w: '70vw',
          h: '70vh',
        },
      },
      props: {
        showCloseButton: true,
      },
    },
    thunk: RevyreThunk,
  } as Module,

  [REVYRE_LIST]: {
    path: '/revyre/:domainType',
    component: RevyreList,
    dialog: {
      styles: {
        d: {
          w: '70vw',
          h: '70vh',
        },
      },
      props: {
        showCloseButton: true,
      },
    },
    thunk: RevyreThunk,
  } as Module,

  [REVYRE_DETAILS]: {
    path: '/v1/revyre/:domainType/details/:entityId',
    component: RevyreDetails,
    thunk: RevyreThunk,
    breadCrumbs: {
      design: 'legacy',
      items: [
        {
          path: '#/revyre/:domainType',
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'domainName',
          },
        },
        {
          breadcrumbName: {
            routeParamKey: 'entityName',
          },
        },
      ],
    },
  } as Module,

  [REVYRE_WORKFLOW_DETAILS]: {
    path: '/v1/revyre/:domainType/:workflowType/details/:entityId',
    component: RevyreDetails,
    thunk: RevyreThunk,
    breadCrumbs: {
      design: 'legacy',
      items: [
        {
          path: '#/revyre/:domainType/:workflowType',
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'workflowName',
          },
        },
        {
          breadcrumbName: {
            routeParamKey: 'entityName',
          },
        },
      ],
    },
  } as Module,

  [DDP_DETAILS]: {
    path: '/revyre/ddp-status/details/:jobId/:actionType?',
    component: DdpDetails,
    thunk: DdpThunk,
    breadCrumbs: {
      design: 'legacy',
      items: [
        {
          path: '#/revyre/ddp-status/details/:jobId',
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'jobId',
          },
        },
      ],
    },
  } as Module,

  [REVYRE_FILTERS]: {
    component: RevyreFilters,
  } as Module,

  [REVYRE_FORM]: {
    component: RevyreForm,
    dialog: {
      styles: {
        d: {
          w: '78vw',
          h: '90vh',
        },
      },
      props: {
        showCloseButton: true,
      },
    },
    thunk: RevyreFormThunk,
  },

  [REVYRE_NOTIFICATION]: {
    component: RevyreNotificationPopup,
    dialog: {
      styles: {
        d: {
          w: '70vw',
          h: '70vh',
        },
      },
      props: {
        showCloseButton: false,
        closeOnEscape: true,
      },
    },
    thunk: RevyreFormThunk,
  },

  [UPLOAD_FORM]: {
    component: UploadForm,
    dialog: {
      styles: {
        d: {
          w: '36vw',
          h: 'auto',
        },
        m: {
          w: '92vw',
          h: 'auto',
        },
      },
      props: {
        showCloseButton: true,
        closeOnEscape: true,
      },
    },
    thunk: RevyreFormThunk,
  },
};

export default module;
